<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <pdq-heading element="h5">Hide conditions</pdq-heading>
    </div>
    <pdq-divider></pdq-divider>
    <div class="card__content">
      <div>Hide widget if all conditions are true:</div>
      <product-page-conditions [formGroup]="formGroup.get('conditions')" [shop]="shop"></product-page-conditions>
    </div>
  </div>
</pdq-card>
